<template>
  <div>
    <switchingcentrebasic
      :switchingcentres="switchingCentres"
      :isloading="isLoading"
      @switchingCentreSaved="fetchSwitchingCentres()"
      @switchingCentreAdded="setLocationLength()"
      @searchInitiated="setLocationLength()"
    ></switchingcentrebasic>
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import SwitchingCentreBasic from "@/components/SwitchingCentreBasic.vue";

export default {
  components: {
    switchingcentrebasic: SwitchingCentreBasic
  },
  data() {
    return {
      isLoading: true,
      switchingCentresLength: [],
      switchingCentres: [],
    };
  },
  computed: {},
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/switchingCentreBasic'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
  methods: {
    fetchSwitchingCentres() {
       this.isLoading = true,
      Api()
        .get("/switchingCentres/active")
        .then(response => {
          this.switchingCentres = response.data;
          this.isLoading = false
        });
    },
   initialize() {
     this.fetchSwitchingCentres();
    }
  }
};
</script>
